import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import ReplacementPage from './ReplacementPage';
import SavingsPage from './SavingsPage';
import AdminPortal from './AdminPortal';

function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/replacement" element={<ReplacementPage />} />
        <Route path="/savings" element={<SavingsPage />} />
        <Route path="/admin" element={<AdminPortal />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRouter;

